import { cn } from "@/lib/utils";

export type StatusTone = "ok" | "neutral";

interface StatusPillProps {
  label: string;
  // "ok" = confirmed / documented (mint), "neutral" = worth knowing (grey).
  tone?: StatusTone;
}

const toneClass: Record<StatusTone, string> = {
  ok: "bg-tone-mint text-tone-mint-ink",
  neutral: "bg-line text-ink-muted",
};

// Small rounded label on a card ("Documented", "Worth knowing") - the
// preview's `.status` pill.
const StatusPill = ({ label, tone = "ok" }: StatusPillProps) => (
  <span
    className={cn(
      "inline-block justify-self-start rounded-full px-2.5 py-0.5 text-[12.5px] leading-snug font-bold",
      toneClass[tone],
    )}
  >
    {label}
  </span>
);

export default StatusPill;
